<template>
  <div :class="classes" @click="onClick">
    <div class="panel__content" data-test-id="panel-content">
      <slot />
    </div>
  </div>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export const sides = ['left', 'right'];

export default {
  name: 'EPanel',
  mixins: [classes],
  props: {
    backdrop: {
      type: Boolean,
      default: true,
      cssClass: true,
    },
    /**
     * The side for the panel `left, right`
     */
    side: {
      type: String,
      default: 'left',
      validator: (value) => sides.includes(value),
      cssClass: true,
    },
    /**
     * The visibility for the panel
     */
    visible: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
  },
  methods: {
    onClick(event) {
      // we do not want clicking on the panel's content to also close it
      if (event.target === this.$el) {
        this.$emit('click', event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$width: 250px;

.panel {
  position: fixed;
  top: 0;
  z-index: $z-index-2l;
}

.panel__content {
  @include elevation(1);

  height: 100%;
  width: $width;
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  background-color: $white;
  transition: all $timing-s $easing;
}

.panel--backdrop {
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $gray-70-40;
    opacity: 0;
    visibility: hidden;
    transition: all $timing-s ease-in-out;
  }

  &.panel--visible::before {
    visibility: visible;
    opacity: 1;
  }
}

.panel--side-left .panel__content {
  left: -$width;
}

.panel--side-right .panel__content {
  right: -$width;
}

.panel--side-left.panel--visible .panel__content {
  left: 0;
}

.panel--side-right.panel--visible .panel__content {
  right: 0;
}
</style>

<docs>
```js
let left = false;
let right = false;

<div>
  <button type="button" @click="left = !left">Toggle left panel</button>
  <EPanel :visible="left">
    Content
  </EPanel>
</div>

<div>
  <button type="button" @click="right = !right">Toggle right panel</button>
  <EPanel side="right" :visible="right">
    Content
  </EPanel>
</div>
```
</docs>
